export const industryHero = {
  eyebrow: '行业咨询',
  title: '行业洞察与专业内容中心',
  titleHighlight: '观点 · 研究 · 趋势',
  subtitle: '建设华辉数智的行业洞察和专业内容中心，持续更新行业观点、研究与专业内容。',
  desc: '与「相关资料」区分：相关资料承载企业与项目资料下载，行业咨询承载持续更新的行业观点与研究。',
};

export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  keywords: string[];
}

export const articleCategories = [
  '全部',
  'AI 应用',
  '乡村数字经济',
  '县域数字商业',
  '数字消费与权益',
  '供应链数字化',
  '系统集成',
  '政策与趋势',
];

export const articles: Article[] = [
  {
    id: 'AI-001',
    title: '人工智能在县域场景中的应用路径',
    category: 'AI 应用',
    date: '2026.08',
    summary:
      '从 TOMA 智能体出发，探讨 AI 应用如何在县域商户、农产品上行与数字服务中落地，降低县域数字化的门槛。',
    keywords: ['TOMA 智能体', '县域 AI', '应用交付'],
  },
  {
    id: 'RURAL-001',
    title: '乡村数字经济的落地逻辑：从单品到网络',
    category: '乡村数字经济',
    date: '2026.08',
    summary:
      '乡村数字经济不是单点数字化，而是通过数字货架、ePin 溯源与信用进货构建可复制的商业网络。',
    keywords: ['乡村数字经济', '农产品上行', '数字货架'],
  },
  {
    id: 'COUNTY-001',
    title: '县域数字商业基础设施的建设要点',
    category: '县域数字商业',
    date: '2026.07',
    summary:
      '县域数字商业基础设施需要同时解决「经营入口」与「数据回流」，形成可运营、可清分的商业底座。',
    keywords: ['县域商业', '基础设施', '数据回流'],
  },
  {
    id: 'CONSUM-001',
    title: '数字消费与权益运营如何驱动复购',
    category: '数字消费与权益',
    date: '2026.07',
    summary:
      '数字消费权益的可核销性与社交传播属性，是驱动县域消费复购与用户活跃的关键。',
    keywords: ['数字消费', '权益运营', '复购'],
  },
  {
    id: 'SUPPLY-001',
    title: '供应链数字化与智能清分的协同价值',
    category: '供应链数字化',
    date: '2026.06',
    summary:
      '供应链数字化与智能清分的结合，让多方协同结算从复杂走向透明，沉淀为可运营的数据资产。',
    keywords: ['供应链', '智能清分', '多方协同'],
  },
  {
    id: 'INTEG-001',
    title: 'AI 应用交付与系统集成的工程化实践',
    category: '系统集成',
    date: '2026.06',
    summary:
      '从研发、集成到部署、运维，AI 应用交付需要工程化的系统集成能力，而非单一模型能力。',
    keywords: ['系统集成', 'AI 交付', '部署运维'],
  },
  {
    id: 'POLICY-001',
    title: '人工智能+ 与县域商业的政策窗口',
    category: '政策与趋势',
    date: '2026.05',
    summary:
      '人工智能、数字乡村、县域商业与数据要素四大国家战略方向叠加，为县域数字商业释放政策窗口。',
    keywords: ['政策', '人工智能+', '数据要素'],
  },
];